export default "__VITE_ASSET__yH1HalNZ__"